import axios from "axios";
import { HttpClient, RequestParams } from "../../utils/api/http-client";
import IBaseListingResponse from "../../utils/api/base-listing-response";

import { ACCESS_TOKEN, LANGUAGE_CODE } from "../../utils/helpers/constants";
import { IBadgeCharity, IBadgeCharityDetails } from "../../models/badge_charity/response";
import { IBadgeCharityQuery } from "../../models/badge_charity/query";
import { ICreateBadgeCharity, IUpdateBadgeCharity } from "../../models/badge_charity/request";

class BadgeCharityService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  getAllBadgeCharities = (query: IBadgeCharityQuery, params?: RequestParams) =>
    this.http.request<IBaseListingResponse<IBadgeCharity>>({
      path: `/badge-charity`,
      method: "GET",
      query,
      ...params,
    });

  getBadgeCharity = (id: number, params?: RequestParams) =>
    this.http.request<IBadgeCharityDetails>({
      path: `/badge-charity/${id}`,
      method: "GET",
      ...params,
    });

  createBadgeCharity = (data: ICreateBadgeCharity, params?: RequestParams) =>
    this.http.request<IBadgeCharity>({
      path: "/badge-charity",
      method: "POST",
      body: data,
      ...params,
    });

  updateBadgeCharity = (id: number, data: IUpdateBadgeCharity, params?: RequestParams) =>
    this.http.request<IBadgeCharity>({
      path: `/badge-charity/${id}`,
      method: "PUT",
      body: data,
      ...params,
    });

  deleteBadgeCharity = (id: number, params?: RequestParams) =>
    this.http.request<IBadgeCharity>({
      path: `/badge-charity/${id}`,
      method: "DELETE",
      ...params,
    });
}

export default BadgeCharityService;